import React, { useEffect, useState } from 'react'
import logo from "./ll.png";

export default function LoadingTwo({toggle}) {

    const [showLoading, setShowLoading] = useState(false);
    useEffect(() => {
        setShowLoading(toggle);
    },[toggle])
  return (
    <>
      {showLoading && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-100 z-50">
          <div className="relative">
            <img
              src={logo}
              alt="Logo"
              className="w-24 h-24 rounded-full animate-spin"
            />
          </div>
        </div>
      )}
    </>
  );
}
